import { useState, useEffect, useRef } from "react";

/**
 * useInView
 * Returns [ref, isVisible] — triggers once when the element scrolls into view.
 * @param {number} threshold - 0 to 1, how much of the element must be visible
 */
const useInView = (threshold = 0.12) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);

  return [ref, visible];
};

export default useInView;